// Brands allowed to be created
export const ALLOWEDBRANDS = ['NEX', 'GDY', 'CON', 'LLG', 'ATS', 'HKK']
